import React from "react";
import { Tag } from "@flixbus/honeycomb-react";
import type { ChipTagProps } from "../CompositionChip/CompositionChip.types";

const OperatorTag: React.FC<ChipTagProps> = ({ label, closeProps }) => (
  <Tag display="outlined" closeProps={closeProps}>
    {label}
  </Tag>
);

export default OperatorTag;
